import { Component, OnInit } from '@angular/core';
import { EmployeesDetailsComponent } from '../../employees-details/employees-details.component';
import { ModalService } from 'mis-crystal-design-system/modal';
import { CommonService } from 'src/app/trip-view/services/common.service';
import { EnvironmentService } from 'src/app/trip-replay/services/img-source.service';
@Component({
  selector: 'app-attendance',
  templateUrl: './attendance.component.html',
  styleUrls: ['./attendance.component.scss']
})
export class AttendanceComponent implements OnInit {
  imgSrc: string;

  constructor(private testPopup: ModalService,private commonService: CommonService, private envService: EnvironmentService) { }
  initialState = {}
  attendance:any={}
  ngOnInit(): void {
    this.imgSrc = this.envService.getImgSrc();
    this.commonService.attendance$.subscribe((data)=>
    {
      this.attendance=data
      console.log('attendance',this.attendance);
      
    })
  }
openModal()
{
  this.testPopup.show(EmployeesDetailsComponent,  { closeOnBackdropClick: true });
}
}
